module.exports = __webpack_public_path__ + "static/media/10k.8aa3de07.webp";